/* eslint-disable no-underscore-dangle */
import moment from 'moment';

import { COMPONENT_KEY_VALUE_BY_TYPE } from 'packages/utils/constants/eventTypes';
import { DateUtil } from 'packages/utils/dates';

import { TYPE_OF_COMPONENTS } from 'constants/commons';

import { AUX_FIELDS_EXTRA } from '../../constants';

export const PAGE_SIZE_BY_DEFAULT = 10;
export const PAGE_SIZE_BY_DEFAULT_MOBILE = 5;

const formatDate = val => {
  if (val?._seconds >= 0 && val?._nanoseconds >= 0) {
    return moment(DateUtil.toDate(val._seconds, val._nanoseconds)).format('DD-MM-YYYY HH:mm:ss');
  }
  return null;
};

const buildCustomKey = (componentId, label) => `${componentId}_${label?.replaceAll(' ', '_')}`;

export const buildDataSource = ({ records, division }) => {
  const hits = records?.hits?.hits || [];

  if (hits.length === 0) return [];

  return hits.reduce((acc, hit) => {
    const { _source: source, _id: id } = hit;
    let record = {
      key: id,
    };

    const components = source.eventType?.components || [];

    components.forEach(element => {
      if (!COMPONENT_KEY_VALUE_BY_TYPE[element.type]) return;

      const key = buildCustomKey(element.id, element?.label?.name);
      let val = element[COMPONENT_KEY_VALUE_BY_TYPE[element.type]];

      if (element.type === TYPE_OF_COMPONENTS.DATE) {
        val = formatDate(val);
      }

      record = {
        ...record,
        [key]: val,
      };
    });

    const user = source?.user || null;
    if (user) {
      record = {
        ...record,
        [AUX_FIELDS_EXTRA.userName]: `${user.firstName} ${user.lastName}`,
      };
    }

    const date = source?.createdAtDevice;
    if (date && !!date?._seconds && !!date?._nanoseconds) {
      record = {
        ...record,
        [AUX_FIELDS_EXTRA.eventDate]: formatDate(date),
      };
    }

    const eventType = source.trigger;
    if (eventType) {
      record = {
        ...record,
        [AUX_FIELDS_EXTRA.eventType]: eventType?.name,
      };
    }

    if (division && division?.name) {
      record = {
        ...record,
        [AUX_FIELDS_EXTRA.division]: division.name,
      };
    }

    const locations = source?.locations || [];
    if (locations.length > 0) {
      record = {
        ...record,
        [AUX_FIELDS_EXTRA.location]: locations.map(location => location?.name).join(', '),
      };
    }

    acc.push(record);

    return acc;
  }, []);
};

export const buildTableParams = ({
  formId = '',
  uid = '',
  orgId = '',
  range = {},
  interval = '',
  divisionIds = [],
  triggerIds = [],
  lastPosition = 0,
  pageSize = PAGE_SIZE_BY_DEFAULT,
  sortFields = [],
  locationIds = [],
  locationGroupId = null,
  columnFilters = {},
}) => {
  let dashboardParams = {
    formId,
    uid,
    organizationId: orgId,
    range,
    interval,
    divisionIds,
    lastPosition,
    pageSize,
    locationIds,
    locationGroupId,
  };

  if (triggerIds.length > 0) {
    dashboardParams = {
      ...dashboardParams,
      triggerIds,
    };
  }
  if (sortFields.length > 0) {
    dashboardParams = {
      ...dashboardParams,
      sortFields,
    };
  }
  if (Object.keys(columnFilters).length > 0) {
    dashboardParams = {
      ...dashboardParams,
      columnFilters,
    };
  }

  return dashboardParams;
};
